import installationsUnitInstallationPrice from './getInstallationsUnitInstallationPrice';
import IInstallation from './IInstallation';

const installationsTotalInstallationPrice = (
  installations: IInstallation[],
  quantity: number
): number => installationsUnitInstallationPrice(installations) * quantity;

export default installationsTotalInstallationPrice;
